const dealers = {
  dealers: 'Distribuidores',
  new_dealer: 'Nuevo Distribuidor',
  add_emp: 'Nuevo Empleado',
  edit_emp: 'Empleado',
  search_dealers: 'Buscar distribuidores',
  search_employee: 'Search empleados',
  delete_dealers_message: 'Estas seguro que quieres borrarlo',
  confirm_modal_confirm: 'Sí, eliminar',
  update_dealer: 'Distribuidor',
  dealer_info: 'Información del distribuidor',
  all: 'Todo',
  active: 'Activo',
  inactive: 'Inactivo',
  submit: 'Entregar',
  update: 'Actualizar',
  edit: 'Editar',
  organizations: 'Cuentas',
  controllers: 'Controladores',
  emp_role: 'Rol del empleado',
  select_dealer_msg: 'Por favor vaya a Distribuidores y seleccione uno',
  confirm_action: '¿Está seguro de que desea cambiar el estado a',
  card_enrollment: 'Inscripción de credencial',
  card_information: 'Información de la credencial',
  how_you_discover: '¿Cómo descubriste CDVI Cloud?',
  dealer_registration: 'Registro de distribuidor',
  table: {
    company: 'COMPAÑÍA',
    full_name: 'NOMBRE COMPLETO',
    email: 'CORREO ELECTRÓNICO',
    country: 'PAÍS',
    last_login: 'ÚLTIMO ACCESO',
    active: 'ACTIVO',
  },
  form: {
    logo: 'Logo',
    website: 'Sitio web',
    mobile: 'Móvil',
    language: 'Idioma para contacto',
  },
  error: {
    invalid_email: 'Formato de correo inválido',
    invalid_zip: 'Código postal inválido',
  },
  preregistration_success:
    'Le hemos enviado a su correo electrónico un enlace para completar el registro',
  preregistration_error:
    'No se puede completar su solicitud. Por favor, inténtelo más tarde.',
  request: {
    back_to_home: 'Volver a la página de inicio',
    error: 'Ocurrió un error.',
    msg1: 'Hemos recibido su solicitud para convertirse en distribuidor.',
    msg2: '¡Le contactaremos por correo electrónico pronto!',
    thank_you: '¡Gracias, {{ companyName }}!',
  },
  tabs: {
    employees: 'Empleados',
    payment_methods: 'Métodos de pago',
  },
  resend_invitation: 'Reenviar invitación',
  status_changed_successfully: 'Estado cambiado correctamente',
  dealer_user: {
    no_associated_account:
      'Ninguna cuenta asociada. Por favor, contacte a su distribuidor para que le asigne una.',
  },
};

export default dealers;
